import { selectUser } from '@centerpiece/components';
import { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import {
  useGetMessageContactsQuery,
  useGetCommentContactsQuery,
  useGetContactQuery,
  useGetProjectTypesQuery,
  useGetSubscribersQuery,
  useGetTeamsQuery,
} from 'store/api';
import {
  CommentContact,
  Contact,
  MessageContact,
  ProjectType,
  Subscriber,
  Team,
} from 'store/api/models';
import { useIndexContext } from './index.context';

export type AnalyticContextContent = {
  contactRecord: Contact;
  team: Team;
  setTeam: React.Dispatch<React.SetStateAction<Team>>;
  individual: Contact;
  setIndividual: React.Dispatch<React.SetStateAction<Contact>>;
  projectType: ProjectType;
  setProjectType: React.Dispatch<React.SetStateAction<ProjectType>>;
  teams: Team[];
  projectTypes: ProjectType[];
  subscribers: Subscriber[];
};
export const AnalyticContext = createContext<AnalyticContextContent>({
  contactRecord: {} as Contact,
  team: {} as Team,
  setTeam: () => {},
  individual: {} as Contact,
  setIndividual: () => {},
  projectType: {} as ProjectType,
  setProjectType: () => {},
  teams: [],
  projectTypes: [],
  subscribers: [],
});

export const AnalyticProvider = ({
  bid,
  children,
}: {
  bid?: boolean;
  children: any;
}) => {
  const { contactRecord } = useIndexContext();
  const [team, setTeam] = useState<Team>(
    contactRecord?.form?.authorization === 'Team Leader' &&
      contactRecord?.form?.team
      ? contactRecord?.form?.team
      : ({ id: 0, name: 'All' } as Team)
  );
  const [individual, setIndividual] = useState<Contact>({
    id: 0,
    firstname: 'All',
    name: 'All',
  } as Contact & { name: string });
  const [projectType, setProjectType] = useState<ProjectType>({
    id: bid ? -1 : 0,
    name: bid ? 'All Bids' : 'All',
  } as ProjectType);
  const { data: teams = [], isLoading: teamsLoading } = useGetTeamsQuery({});
  const { data: projectTypes = [], isLoading: projectTypesLoading } =
    useGetProjectTypesQuery({});
  const { data: subscribers = [] as Subscriber[], isLoading } =
    useGetSubscribersQuery({ params: { nested: 'all' } });

  useEffect(() => {
    setProjectType({
      id: bid ? -1 : 0,
      name: bid ? 'All Bids' : 'All',
    } as ProjectType);
    setIndividual({
      id: 0,
      firstname: 'All',
      name: 'All',
    } as Contact & { name: string });
    setTeam(
      contactRecord?.form?.authorization === 'Team Leader' &&
        contactRecord?.form?.team
        ? contactRecord?.form?.team
        : ({ id: 0, name: 'All' } as Team)
    );
    // return function cleanup() {

    // }
  }, [bid]);

  return (
    <AnalyticContext.Provider
      value={{
        contactRecord,
        team,
        setTeam,
        individual,
        setIndividual,
        projectType,
        setProjectType,
        teams,
        projectTypes,
        subscribers,
      }}
    >
      {children}
    </AnalyticContext.Provider>
  );
};

export const useAnalyticContext = () => useContext(AnalyticContext);
